module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img (15).ef25848c.jpg";